/*
 * @Description: axios配置
 * @Date: 2019-09-06 14:08:06
 * @LastEditors: Ji Yinghao
 * @LastEditTime: 2019-10-28 18:28:39
 */


import Vue from 'vue'
import axios from 'axios';
Object.assign(axios.defaults, {
    timeout: 10000,
    baseURL: '/apii/',
    withCredentials: true //让ajax携带cookie
});

// 全局拦截axios
axios.interceptors.response.use((response) => {
    if (response.data.result == 1002) {
        window.history.back(-1);
    }
    return response;
}, (res) => {
    if (res.response.data.result == 1002) {
        window.history.back(-1);
    }
    return res;
})

Vue.prototype.$axios = axios;
export default axios;